// extracted by mini-css-extract-plugin
export var assigneeBadge = "_j6-0";
export var assigneeDetails = "_j6-1";
export var assigneeInfo = "_j6-2";
export var dropdownContainer = "_j6-4";
export var dropdownImage = "_j6-5";
export var editAssigneeInfo = "_j6-3";
export var editAssigneeModalContainer = "_j6-6";
export var hidden = "_j6-8";
export var input = "_j6-7";